import { render, staticRenderFns } from "./ProfileTextField.vue?vue&type=template&id=3195f503"
import script from "./ProfileTextField.vue?vue&type=script&lang=js"
export * from "./ProfileTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports